const DynamicAllowDecision = (props) => {
  const visited = props?.row?.original?._source?.visited || props?.row?.original?.visited;
  return (
    <div
      className={`dynamic-phishing-emails__table__decision dynamic-phishing-emails__table__decision--${
        visited === ""
          ? "unknown"
          : visited === "auto"
            ? "auto"
            : visited
              ? "visited"
              : "not-visited"
      } `}>
      {visited === "" ? "" : visited === "auto" ? "auto" : visited ? "yes" : "no"}
    </div>
  );
};

export default DynamicAllowDecision;
